var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 135,
    viewBox: "0 0 170 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1006_30)",
    filter: "url(#filter0_i_1006_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1763 58.3353H0.801872L16.3754 76.2484L0 94.9896H31.6112L30.1763 58.3353Z",
    fill: "#279785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7612 71.2798L30.1763 58.3353V74.9409L23.7612 71.2798Z",
    fill: "#32B49E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.782 58.3353H169.198L153.625 76.2484L170 94.9896H138.347L139.782 58.3353Z",
    fill: "#279785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.239 71.2798L139.781 58.3353V74.9409L146.239 71.2798Z",
    fill: "#32B49E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6146 34.1026L84.9999 0.499146L141.427 34.1026V101.353L84.9999 135L28.6146 101.353V34.1026Z",
    fill: "#A8CFA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8317 41.0324V38.4174L38.0263 37.1099",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.078 34.6691L80.7796 11.613",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeDasharray: "11.14 11.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8053 10.3927L84.9999 9.08521L87.1946 10.3927",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2885 12.8335L129.948 35.8895",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeDasharray: "11.14 11.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.016 37.1099L134.21 38.4174V41.0324",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.21 45.8702V92.0259",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeDasharray: "11.14 11.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.21 94.4667V97.0817L132.016 98.3893",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.922 100.786L89.2626 123.886",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeDasharray: "11.14 11.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1946 125.106L84.9999 126.414L82.8053 125.106",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7536 122.666L40.052 99.6096",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeDasharray: "11.14 11.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0263 98.3893L35.8317 97.0817V94.4667",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8317 89.5852V43.4731",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeDasharray: "11.14 11.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.281 71.2799H23.7612V103.14H146.281V71.2799Z",
    fill: "#32B49E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1006_30",
    x: 0,
    y: 0,
    width: 170,
    height: 139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1006_30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1006_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 135,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeIcon);
export default __webpack_public_path__ + "static/media/badge-icon.624760e61ff190f3e267295f90665308.svg";
export { ForwardRef as ReactComponent };